import { FormikValues } from 'formik';

import { countryOptions } from '@react/constants/countries';
import { CardValidationFields, CardFieldValidation } from '@redux/ducks/paymentMethods';

export const isInvalidField = (fields: CardValidationFields, name: string): boolean => {
  const field: CardFieldValidation = fields[name];

  return field && !field.isValid && !field.isPotentiallyValid;
};

export const isInvalidForm = (fields: CardValidationFields) => {
  const values: CardFieldValidation[] = Object.values(fields);
  return values.length === 0 || values.some(field => field.isEmpty || !field.isValid);
};

export const dropEmptyFields = (values: FormikValues): FormikValues =>
  Object.keys(values)
    .filter(key => values[key])
    .reduce((obj, key) => {
      obj[key] = values[key];
      return obj;
    }, {});
export const mapCountryNameToCode = (value?: Nullable<string>) =>
  countryOptions.find(country => country.label === value)?.value;
export const cleanPhoneNumber = (phoneNumber: string): string => phoneNumber.replace(/[^\d]/g, '');
